module.exports = __webpack_public_path__ + "static/media/ecki.b0cffb2c.jpeg";